import React from 'react';
import { useRouter } from 'next/router';
import {
  useTopIssuersContext,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesContexts/TopIssuersContext';

import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import LinkTable from '@/creditflowresearch/ui/common/components/LinkTable';
import {
  topCompaniesTablesCommonProps,
  getTopCompanyColumns,
} from '../common/tableConfigs';
import { getIssuerRoute, getParentRoute } from '@/creditflowresearch/Router/RouteWithRedirect/getNewRoute';
import { ISSUER_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';

const TopIssuers = () => {
  const {
    query: {
      companyViewId,
    },
  } = useRouter();
  const {
    collection,
    totalCount,
    page,
    perPage,
    paginate,
    isFetching,
    showVolume,
  } = useTopIssuersContext();

  return (
    <>
      { isFetching && <Spinner isVisible overlay /> }
      <LinkTable
        { ...topCompaniesTablesCommonProps }
        columns={ getTopCompanyColumns({
          showVolume,
          companyViewId,
          companyRole: ISSUER_NAME,
        }) }
        data={ collection }
        page={ page }
        perPage={ perPage }
        totalCount={ totalCount }
        onPageChange={ (page) => paginate(page.selected) }
        isFetching={ isFetching }
        getRoutePath={ companyViewId ? getIssuerRoute : getParentRoute }
        emptyMessageText="No new issuance during the selected period."
        paginatorDataTest={ companyViewId ? 'linkTablePaginatorIssuers' : 'linkTablePaginatorParents' }
        rowDataTest={ companyViewId ? 'linkTableRowIssuers' : 'linkTableRowParents' }
      />
    </>
  );
};

export default TopIssuers;
